import React from 'react';
import { Box } from '@material-ui/core';
import { useStyles as useStylesBase } from '../common/styles/base';
import { useStyles as useStylesMobile } from '../common/styles/mobile';

const LoginInfoSection = () => {
  const classesBase = useStylesBase();
  const classesMobile = useStylesMobile();

  const classes = { ...classesBase, ...classesMobile };

  return (
    <Box className={classes.contactInfoWrapper}>
      <Box className={classes.contactInfoValue}>Техническая поддержка</Box>
      <Box className={classes.contactItem}>
        <u>Круглосуточно:</u>
      </Box>
      <Box className={classes.contactItem}>
        <a href='tel:88002226561'>8(800)222-65-61</a> - бесплатно по России
      </Box>
      <Box className={classes.contactItem}>
        <a href='tel:+74959276561'>+7(495)927-65-61</a> - бесплатно для Москвы
      </Box>
      <Box className={classes.contactItem}>
        <u>Отправить запрос в любое время:</u>
      </Box>
      <Box className={classes.contactItem}>
        <a href='mailto:support@vtorium.ru'>support@vtorium.ru</a>
      </Box>
    </Box>
  );
};

export default LoginInfoSection;
